import { useSelector } from 'react-redux';
import { getX50CurrentSector, getX50PreviousSector } from '../selectors';
import { IStore } from 'store/interface';

export const useGameRoundNumbers = () => [
  useSelector<IStore, number>(getX50CurrentSector),
  useSelector<IStore, number>(getX50PreviousSector),
];
